import {APP_ID, Inject, NgModule, PLATFORM_ID} from '@angular/core';

import { AppModule } from './app.module';
import { AppComponent } from './app.component';
import {BrowserModule} from "@angular/platform-browser";
import {isPlatformBrowser} from "@angular/common";

@NgModule({
  imports: [
    AppModule,
    BrowserModule,
  ],
  providers:[
  ],
  bootstrap: [AppComponent],
})
export class AppBrowserModule {
  constructor(
    @Inject(PLATFORM_ID) platformId: object,
    @Inject(APP_ID) appId: string,
  ) {
    const platform = isPlatformBrowser(platformId) ? 'in the browser module' : 'on the server module';
    console.log(`Running ${platform} with appId=${appId}`);
  }
}
